<template>
	<span @click="onFavoriteClicked" style="cursor: pointer" v-if="orderId !== 0">
		<i v-if="isFavorite" class="fas fa-star" style="color: orange; font-size: 16pt"></i>
		<i v-else class="far fa-star" style="color: black; font-size: 16pt"></i>
	</span>
</template>

<script>
import { FavoritesService } from '@/services';

export default {
	name: 'favorite-indicator',
	components: {},
	props: {
		orderId: {
			default: 0
		}
	},
	data() {
		return {
			isFavorite: false
		}
	},
	mounted() {
		if (this.orderId !== 0) {
			FavoritesService.isFavorite(this.$route.params.id)
				.then(res => {
					this.isFavorite = res;
				})
				.catch(err => {
					console.error('Error checking isFavorite: ', err);
				})
		}
	},
	methods: {
		onFavoriteClicked() {
			this.isFavorite = !this.isFavorite;

			if (this.isFavorite) {
				FavoritesService.setFavorite(this.orderId)
					.then(res => {
						this.$store.dispatch('UPDATE_FAVORITES');
					});
			}
			else {
				FavoritesService.removeFavorite(this.orderId)
					.then(res => {
						this.$store.dispatch('UPDATE_FAVORITES');
					});
			}
		}
	}
}
</script>

<style scoped>
</style>
